"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FabricMap = exports.ReactMapboxGlMap = void 0;
const react_1 = __importDefault(require("react"));
const react_mapbox_gl_1 = __importDefault(require("react-mapbox-gl"));
const FabricMapSync_1 = require("./FabricMapSync");
const Context_1 = require("./Context");
const util_1 = require("../util");
const debounce_1 = __importDefault(require("lodash/debounce"));
exports.ReactMapboxGlMap = (0, react_mapbox_gl_1.default)({
    accessToken: (0, util_1.getApiKey)(),
    interactive: true,
    preserveDrawingBuffer: true,
});
/**
 * This component adds an observer to the DOM container that will trigger
 * `map.resize` when this is resized. `map.resize` tells the map to recalculate
 * how much space to take up in its container.
 */
const Resizer = (0, Context_1.withMap)(({ mapRef, map }) => {
    /**
     * Attach a resize observer to the map element. When the map's container changes, the map will resize to fit.
     */
    react_1.default.useLayoutEffect(() => {
        const RO = new ResizeObserver((0, debounce_1.default)(() => {
            map.resize();
        }, 100));
        if (mapRef.current.container) {
            RO.observe(mapRef.current.container);
        }
        return () => {
            RO.disconnect();
        };
    }, [mapRef, map]);
    /**
     * We're also using this component to add a data-qa tag to the canvas element.
     * Saves us from adding a second wrapper just to do this one thing.
     */
    react_1.default.useEffect(() => {
        map.getCanvas().dataset.qa = "fabric-mapbox-canvas";
    }, [map]);
    return null;
});
/**
 * This is the actual `<ReactMapboxGlMap>`.
 * `FabricMapProvider` renders it inside the `mapPortalDiv`, which is then moved around the app with `append`.
 */
exports.FabricMap = react_1.default.memo((props) => {
    const mapProps = Object.assign({ containerStyle: {
            height: "100%",
            width: "100%",
        }, style: 
        // This is the default Hybrid style
        "mapbox://styles/acrevalue/cjzafiqdo09e61cpijj7v6d4z?optimize=true" }, props);
    const { fitBounds, fitBoundsOptions } = mapProps || {
        fitBounds: undefined,
        fitBoundsOptions: undefined,
    };
    const mapRef = react_1.default.useRef(null);
    return (react_1.default.createElement(exports.ReactMapboxGlMap, Object.assign({ ref: mapRef }, mapProps),
        react_1.default.createElement(Resizer, { mapRef: mapRef }),
        react_1.default.createElement(Context_1.FabricMapFitBoundsContext.Provider, { value: { fitBounds, fitBoundsOptions } },
            props.sync && react_1.default.createElement(FabricMapSync_1.FabricMapSync, null),
            mapProps.children)));
});
exports.FabricMap.displayName = "FabricMap";
